var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0968 7.59259C49.6989 8.45679 50 9.50617 50 10.7407C50 11.9753 49.6989 13.0247 49.0968 13.8889L25.7419 47.4074L21.3548 53.7037C20.7527 54.5679 20.0215 55 19.1613 55C18.3011 55 17.5699 54.5679 16.9677 53.7037L12.5806 47.4074L0.903226 30.6481C0.301075 29.784 0 28.7346 0 27.5C0 26.2654 0.301075 25.2161 0.903226 24.3519L5.29032 18.0556C5.89247 17.1914 6.62366 16.7593 7.48387 16.7593C8.34409 16.7593 9.07527 17.1914 9.67742 18.0556L19.1613 31.713L40.3226 1.2963C40.9247 0.432099 41.6559 0 42.5161 0C43.3763 0 44.1075 0.432099 44.7097 1.2963L49.0968 7.59259Z",
    fill: "#70B603"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e80691457ca31df99cfa0d6bc9bcebc7.svg";
export { ForwardRef as ReactComponent };